/**
 * Selector de moneda USD / UYU.
 *
 * El estado inicial (html[data-currency]) lo fija snippets/currency-head.liquid antes del render.
 * Este script solo reacciona a la elección: la persiste, actualiza el atributo (CSS hace el resto)
 * y la registra como atributo del carrito, igual que el theme anterior.
 */
(() => {
  const root = document.documentElement;
  if (!root.dataset.currency) return; // Sin cotización válida la feature está apagada.

  const COOKIE_MAX_AGE = 60 * 60 * 24 * 7;
  const VALID_CURRENCIES = ['usd', 'uyu'];

  // Mismo criterio que currency-head.liquid: si hay cookies heredadas de un path
  // más específico, la de path=/ queda última en document.cookie y gana.
  const readCookie = () => {
    const matches = Array.from(document.cookie.matchAll(/(?:^|;\s*)currency=(usd|uyu)(?=;|$)/g));
    return matches.length ? matches[matches.length - 1][1] : null;
  };

  // Default-path (RFC 6265 §5.1.4) de un path.
  const defaultPath = (path) => {
    const lastSlash = path.lastIndexOf('/');
    return lastSlash <= 0 ? '/' : path.slice(0, lastSlash);
  };

  // Default-paths ancestros del path actual: ahí pudo quedar una cookie del theme anterior.
  const ancestorPaths = () => {
    const paths = [];
    let path = defaultPath(location.pathname);
    while (path !== '/') {
      paths.push(path);
      path = defaultPath(path);
    }
    return paths;
  };

  const syncButtons = () => {
    document.querySelectorAll('[data-currency-button]').forEach((button) => {
      button.setAttribute('aria-pressed', String(button.dataset.currencyButton === root.dataset.currency));
    });
  };

  // Guarda la moneda con path=/ y expira las cookies heredadas de paths más específicos
  // (el theme anterior las guardaba sin path) para que no compitan con la nueva.
  const persistCurrency = (currency) => {
    ancestorPaths().forEach((path) => {
      document.cookie = `currency=; path=${path}; max-age=0`;
    });
    document.cookie = `currency=${currency}; path=/; max-age=${COOKIE_MAX_AGE}; SameSite=Lax`;
  };

  const selectCurrency = (currency) => {
    if (!VALID_CURRENCIES.includes(currency)) return;

    // Se persiste aunque sea la moneda ya activa: puede venir del default o de una cookie heredada.
    persistCurrency(currency);
    if (currency === root.dataset.currency) return;

    root.dataset.currency = currency;
    syncButtons();

    fetch(`${FoxTheme.routes.cart_update_url}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { currency: currency.toUpperCase() } })
    }).catch(() => {});

    document.dispatchEvent(new CustomEvent('currency:change', { detail: { currency } }));
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-currency-button]');
    if (button) selectCurrency(button.dataset.currencyButton);
  });
  document.addEventListener('shopify:section:load', syncButtons);

  // bfcache: la página restaurada puede mostrar el estado viejo; releer la cookie y refrescar.
  window.addEventListener('pageshow', (event) => {
    if (!event.persisted) return;
    const saved = readCookie();
    if (saved && saved !== root.dataset.currency) root.dataset.currency = saved;
    syncButtons();
  });

  // Si la moneda de esta página salió de una cookie (quizás heredada, con path específico),
  // se normaliza a path=/ para que valga igual en todo el sitio.
  const saved = readCookie();
  if (saved) persistCurrency(saved);

  syncButtons();
})();
